module.exports = __webpack_public_path__ + "static/media/yoda-main.0d7b4ff7.png";